import styled from 'styled-components';

export const BigCircleDiv = styled.div`
  border-radius: 50%;
  position: absolute;
  top: -90vh;
  left: -62vw;
  width: 180vw;
  height: 180vh;
  z-index: -20;
  opacity: 0.9;
  background: linear-gradient(
    80deg,
    ${({ theme }) => theme.palette.gradient.light} 0%,
    ${({ theme }) => theme.palette.gradient.dark} 100%
  );
  box-shadow: ${({ theme }) => theme.shadows[9]};
`;

export const MobileCircleDiv = styled.div<{
  mobileHeight: number;
}>`
  border-radius: 50%;
  position: absolute;
  bottom: calc(100% - ${(props) => `${props.mobileHeight + 7}px`});
  left: -159vw;
  width: 420vw;
  height: 420vh;
  z-index: -20;
  opacity: 0.9;
  background: linear-gradient(
    144.21deg,
    ${({ theme }) => theme.palette.gradient.light} 0%,
    ${({ theme }) => theme.palette.gradient.dark} 100%
  );
  box-shadow: ${({ theme }) => theme.shadows[9]};
`;

export const CircleWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  z-index: -10;
`;
